import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories, MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-20 bg-primary-950 text-white">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                <i className="ri-file-list-3-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-base font-bold">
                {t("common.siteName")}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/70">
              {t("common.footer.about")}
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white/50">
              {t("common.footer.explore")}
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-white/80 transition-colors hover:text-white cursor-pointer">
                  {t("common.footer.home")}
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-white/80 transition-colors hover:text-white cursor-pointer">
                  {t("common.footer.categoriesLabel")}
                </Link>
              </li>
              <li>
                <Link to="/guides/allchinabuy-spreadsheet" className="text-white/80 transition-colors hover:text-white cursor-pointer">
                  {t("common.footer.guide")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-white/80 transition-colors hover:text-white cursor-pointer"
                >
                  {t("common.buttons.visitMain")}
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white/50">
              {t("common.footer.categoriesLabel")}
            </h4>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-sm">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/80 transition-colors hover:text-white cursor-pointer"
                  >
                    {t(cat.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6">
          <p className="text-xs leading-relaxed text-white/50">
            {t("common.footer.independent")}
          </p>
          <div className="mt-4 flex flex-col items-start justify-between gap-3 text-xs text-white/60 sm:flex-row sm:items-center">
            <span>
              © {new Date().getFullYear()} {t("common.siteName")}.{" "}
              {t("common.footer.copyright")}
            </span>
            <div className="flex flex-wrap gap-4">
              <Link to="/" className="transition-colors hover:text-white cursor-pointer">
                {t("common.footer.privacy")}
              </Link>
              <Link to="/" className="transition-colors hover:text-white cursor-pointer">
                {t("common.footer.terms")}
              </Link>
              <Link to="/" className="transition-colors hover:text-white cursor-pointer">
                {t("common.footer.affiliate")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}